import { useEffect, useState } from "react";
import { CalendarIconSvg, EditDotIconSvg, EditProfileIconSvg } from "../../assets/svg";
import BasicDetails from "./stepOne/BasicDetails";
import SelectItinerary from "./stepTwo/SelectItinerary";
import BuildQuotation from "./stepThree/BuildQuotation";
import { useNavigate, useParams } from "react-router-dom";
import { scrollToTop } from "../../utils/scrollToTop";
import "./style.scss";

const AddLeads = () => {
  const navigate = useNavigate();
  const { stepNumber, customerId } = useParams();
  const [step, setStep] = useState<number>(customerId ? Number(stepNumber || 1) : 1);

  const handleStepClick = (stepNumber: any) => {
    if (stepNumber === 1) navigate('/add-leads');
    if (stepNumber === 2 && stepNumber < step) navigate(`/add-leads/2/${customerId}`);
    if (stepNumber < step) setStep(stepNumber);
  };

  useEffect(() => {
    scrollToTop();
  }, [stepNumber])

  return (
    <>
    <div className="flex flex-col gap-4  items-center add-leads-wrapper">
      <div className="flex flex-col gap-3 items-center w-fit px-3 py-3 rounded-md steps-wrapper">
        <div className="flex gap-2.5 items-center">
          <div onClick={() => handleStepClick(1)} className={`flex items-center justify-center cursor-pointer icon-wrapper active`}>
            <EditProfileIconSvg />
          </div>
          <span className={`line-dash ${step > 1 ? "active" : ""}`}>━━━━━━━━━━</span>
          <div onClick={() => handleStepClick(2)} className={`flex items-center justify-center cursor-pointer icon-wrapper ${step > 1 ? "active" : ""}`}>
            <CalendarIconSvg fill={"white"} />
          </div>
          <span className={`line-dash ${step > 2 ? "active" : ""}`}>━━━━━━━━━━</span>
          <div onClick={() => handleStepClick(3)} className={`flex items-center justify-center cursor-pointer icon-wrapper ${step > 2 ? "active" : ""}`}>
            <EditDotIconSvg fill={"white"} />
          </div>
        </div>
        <div className="flex justify-between step-name-wrapper">
          <span onClick={() => handleStepClick(1)} className={`step-name ${step === 1 ? "active" : "thin-text"}`}>
            Basic Details
          </span>
          <span
            onClick={() => handleStepClick(2)}
            className={`step-name ml-2.5 ${step === 2 ? "active" : step === 3 ? "thin-text" : ""}`}
          >
            Select Itinerary
          </span>
          <span onClick={() => handleStepClick(3)} className={`step-name ${step === 3 ? "active" : ""}`}>
            Build Quotation
          </span>
        </div>
      </div>
    </div>
      <div>
        {step === 1 && <BasicDetails setStepNumber={(item) => setStep(item)} />}
        {step === 2 && <SelectItinerary setStepNumber={(item) => setStep(item)} />}
        {step === 3 && <BuildQuotation setStepNumber={(item) => setStep(item)}/>}
      </div>
      </>
  );
};

export default AddLeads;
